import React, { PureComponent } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import { withRouter } from 'react-router';

class NotFound extends PureComponent {
  render() {
    return (
      <Grid
        container
        spacing={0}
        direction="column"
        alignItems="center"
        justifyContent="center"
        style={{ minHeight: '100vh' }}
      >
        <Typography align="center" variant="h2" gutterBottom={true}>
          404
        </Typography>
        <Typography align="center" variant="h4" gutterBottom={true}>
          Page Not Found
        </Typography>
        <Typography align="center" variant="h6" gutterBottom={true}>
          <Link href="/login">Login</Link>
        </Typography>
      </Grid>
    );
  }
}

export default withRouter(NotFound);
